<style>

</style>

<template>

  <div>
    <div v-if="shouldShowSelectedResourcesActions" style="padding-top: 20px;">
      <div style="display: flex; gap: 10px; align-items: center;">
        <div style="color: #373030; font-size: 14px;">
          {{ selectedResourcesCount }} {{ this.translate('ui_items_selected') }}
        </div>
        <v-btn
          x-small
          color="red"
          outlined
          @click="deleteSelectedResources"
        >
          <v-icon style="font-size: 12px;">mdi-trash-can-outline</v-icon>
          {{ this.translate('ui_delete_btn') }}
        </v-btn>
      </div>
    </div>

    <div
      style="display: none; justify-content: space-between; align-items: center; padding-top: 20px;"
    >
      <v-btn
        v-if="isRemoveSectionResourcesBtnVisible(section)"
        @click="removeSectionResources(section)"
        :color="btnRemoveAllResourcesStatus ? 'error' : 'primary'"
        outlined
        small
        :disabled="!isRemoveSectionResourcesBtnVisible(section)"
      >
        <span v-if="!btnRemoveAllResourcesStatus">
          <v-icon style="font-size: 14px; margin-right: 2px; color: darkred;">mdi-trash-can-outline</v-icon> {{ translate('ui_btn_clear_all') }}
        </span>
        <span v-if="btnRemoveAllResourcesStatus">
          {{ translate('ui_btn_press_again_to_confirm') }}
        </span>
      </v-btn>

      <v-btn
        v-if="section.sectionResources"
        @click="clearResourcesData(section)"
        outlined
        small
      >
        <span>
          {{ translate('dialog_section_ui_btn_clear_resources_data') }}
        </span>
      </v-btn>

      <v-btn
        v-if="section.sectionResources"
        @click="generateResourcesData(section)"
        outlined
        small
      >
        <span>
          {{ translate('dialog_section_ui_btn_generate_resources_data') }}
        </span>
      </v-btn>

      <v-btn
        v-if="section.canSkip"
        color="primary"
        outlined
        small
        @click="toggleSectionVisibility(section)"
      >
        <span v-if="!section.isEnabled">{{ translate('ui_enable_section_btn') }}</span>
        <span v-if="section.isEnabled">{{ translate('ui_disable_section_btn') }}</span>
      </v-btn>
    </div>
  </div>
</template>

<script>

import Mixin from '../../mixins/mixin';

export default {
  components: {},
  mixins: [Mixin],
  name: 'DialogSection',
  props: {
    section: Object,
    selectNextSection: Function,
  },
  data: () => ({
    btnRemoveAllResourcesStatus: null,
  }),
  computed: {
    selectedResourcesCount() {
      return this.section.sectionResources.filter((resource) => resource.isSelected).length;
    },
    shouldShowSelectedResourcesActions() {
      return this.section.sectionResources && this.section.sectionResources.some((resource) => resource.isSelected);
    },
  },
  methods: {
    deleteSelectedResources() {
      this.$store.getters.selectedResources.forEach((resource) => {
        this.deleteResource(null, resource);
      });
    },
    toggleSectionVisibility(section) {
      const sectionToToggle = section.mappedToSection || section;
      // if hiding section
      if (sectionToToggle.isEnabled) {
        if (this.$store.state.activeTemplate.isOnboardingComplete) {
          // hide dialog if onboarding completed
          this.$store.commit('updateState', {
            path: 'activeTemplate.isNavigatorVisible',
            value: false,
          });
        } else {
          // if still onboarding - move to next section
          this.selectNextSection();
        }
      }
      this.toggleSection(sectionToToggle.id);
    },
    isRemoveSectionResourcesBtnVisible() {
      // return section.sectionResources && section.sectionResources.length > 0;
      return false;
    },
    removeSectionResources(section) {
      if (this.btnRemoveAllResourcesStatus === 'pending') {
        const { sectionResources } = this.$store.state.activeTemplate.data.divisions[0];
        // eslint-disable-next-line
        const newSectionResources = sectionResources.filter((sr) => {
          return !section.coreResourceTypes.includes(sr.coreResource.rel);
        });
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.divisions[0].sectionResources',
          value: newSectionResources,
        });
      } else {
        this.btnRemoveAllResourcesStatus = 'pending';
        setTimeout(() => {
          this.btnRemoveAllResourcesStatus = null;
        }, 3000);
      }
    },
  },
};
</script>
